export default __webpack_public_path__ + "static/Matrix-bc2edfb974b8042b3e5bd96f55fe5dc3.png";